import { useEffect } from 'react';
import enums from '@happylife-a/enums';
import utils from '@happylife-a/utils';

const parameterKeys = {
  [enums.payment.PaymentProviderEnum.IDBank]: 'orderId',
  [enums.payment.PaymentProviderEnum.AmeriaBank]: 'orderID',
  [enums.payment.PaymentProviderEnum.YumGo]: 'orderId',
  [enums.payment.PaymentProviderEnum.Stripe]: 'stripeSessionId',
  [enums.payment.PaymentProviderEnum.IDram]: 'orderId',
  [enums.payment.PaymentProviderEnum.Click]: 'orderId',
  // more providers ...
};

function parseAndDecode(value) {
  return !value ? {} : JSON.parse(decodeURIComponent(value || '{}'));
}

function normalizeResponseParams(params) {
  const paramsToProvide = utils.helpers.deep.copy(params);
  delete paramsToProvide.screenName;
  delete paramsToProvide.screenComponentName;

  if (params.paymentProvider === enums.payment.PaymentProviderEnum.AmeriaBank) {
    paramsToProvide.responseCode = paramsToProvide.resposneCode;
    paramsToProvide.orderId = paramsToProvide.orderID;
  }

  const type = paramsToProvide.type;
  delete paramsToProvide.type;

  const paymentProvider = paramsToProvide.paymentProvider;
  delete paramsToProvide.paymentProvider;

  let customParams = {};
  switch (params.paymentProvider) {
    case enums.payment.PaymentProviderEnum.IDram:
    case enums.payment.PaymentProviderEnum.IDBank:
    case enums.payment.PaymentProviderEnum.AmeriaBank:
    case enums.payment.PaymentProviderEnum.YumGo:
    case enums.payment.PaymentProviderEnum.Click:
      customParams = parseAndDecode(paramsToProvide.opaque);
      break;

    case enums.payment.PaymentProviderEnum.Stripe:
      if (paramsToProvide.stripeParams) {
        paramsToProvide.stripeParams = decodeURIComponent(paramsToProvide.stripeParams);
      }

      customParams = parseAndDecode(params.stripeParams);
      break;
  }

  return {
    paymentProvider: paymentProvider,
    params: paramsToProvide,
    type: type,
    customParams: customParams,
  };
}

function useProcessPaymentParams(proceedPaymentResponse, params) {
  const parameterKey = parameterKeys[params?.paymentProvider];
  const parameterValue = params?.[parameterKey];

  useEffect(() => {
    if (!parameterValue) {
      return;
    }

    const {
      paymentProvider,
      params: paramsToProvide,
      customParams,
    } = normalizeResponseParams(params);

    proceedPaymentResponse({
      params: paramsToProvide,
      paymentProvider: paymentProvider,
      customParams: customParams,
    });
  }, [parameterKey, parameterValue]);
}

export default useProcessPaymentParams;
